import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveBadWordsMutationVariables = Types.Exact<{
  badWords: ReadonlyArray<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type SaveBadWordsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveBadWords: boolean };


export const SaveBadWordsDocument = gql`
    mutation SaveBadWords($badWords: [String!]!) {
  saveBadWords(badWords: $badWords)
}
    `;
export type SaveBadWordsMutationFn = Apollo.MutationFunction<SaveBadWordsMutationPage, SaveBadWordsMutationVariables>;

/**
 * __useSaveBadWordsMutation__
 *
 * To run a mutation, you first call `useSaveBadWordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBadWordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBadWordsMutation, { data, loading, error }] = useSaveBadWordsMutation({
 *   variables: {
 *      badWords: // value for 'badWords'
 *   },
 * });
 */
export function useSaveBadWordsMutation(baseOptions?: Apollo.MutationHookOptions<SaveBadWordsMutationPage, SaveBadWordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBadWordsMutationPage, SaveBadWordsMutationVariables>(SaveBadWordsDocument, options);
      }
export type SaveBadWordsMutationHookResult = ReturnType<typeof useSaveBadWordsMutation>;
export type SaveBadWordsMutationResult = Apollo.MutationResult<SaveBadWordsMutationPage>;
export type SaveBadWordsMutationOptions = Apollo.BaseMutationOptions<SaveBadWordsMutationPage, SaveBadWordsMutationVariables>;